import React, { Fragment } from 'react';
import { Helpers } from '../../core/src/helpers';

import '../css/price.less';

export default ({ price={}, spClassName, showListPrice, showSalePrice, pricePrefixText='', displayDifference }) => {
    const difference = displayDifference && price.regularPrice > price.salePrice ? price.regularPrice - price.salePrice : null;
	return(
        <Fragment>
            <span className='list-price'>
                { price.regularPrice &&
                  <span className='price-prefix'>{pricePrefixText}</span>
                }
                { showListPrice
                    && <span className='strike-price'>{Helpers.formatCurrency(price.regularPrice)}</span>
                }
                { difference 
                    && <span className='price-difference'>Save {Helpers.formatCurrency(difference)}</span> 
                }
            </span>
            { showSalePrice
                && <span className={`${spClassName}${!showListPrice ? ' non-sale' : ''}`}>{Helpers.formatCurrency(price.salePrice)}</span>
            }
        </Fragment>
    )
};
